// noinspection JSUnresolvedVariable

import {useContext, useEffect} from 'react'
import {OrderFormContext} from '../contexts/OrderFormContext'
import {getMattingPrice, shouldUseMattingTypePricing, withMattingTypePricing} from './withMattingTypePricing'

const useCalculateTotalPrice = () => {
    const {
        setTotalPrice,
        frameSize,
        images,
        selectedAttributes,
        selectedShape,
        getQuantitySetFromFrameSize,
        signature,
        selectedMattingType,
        isMattingStuff,
        selectedPaperType
    } = useContext(OrderFormContext)

    useEffect(() => {
        _calculateTotalPrice()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frameSize, images, selectedAttributes, signature])

    const _calculateTotalPrice = () => {
        let totalPrice = 0
        let quantitySet = 0

        if (frameSize) {
            totalPrice += parseFloat(frameSize.price)
            quantitySet = getQuantitySetFromFrameSize(frameSize)
        }

        if (selectedAttributes.length > 0) {
            selectedAttributes.forEach(selectedAttribute => {
                switch (selectedAttribute.type) {
                    case 'select': {
                        const selectedValue = selectedAttribute.value

                        let selectedOptionPrice = selectedAttribute.options.filter(
                            ({value}) => value === selectedValue
                        )[0]?.price || 0

                        // PM-492
                        if(isMattingStuff && shouldUseMattingTypePricing(selectedAttribute)) {
                            selectedOptionPrice = withMattingTypePricing(selectedOptionPrice, getMattingPrice(selectedMattingType(), selectedPaperType()), selectedMattingType())
                        }

                        totalPrice += parseFloat(selectedOptionPrice)

                        break
                    }
                    default: {

                    }
                }
            })
        }

        let totalImageAmount = 0
        if (images.length > 0) {
            images.forEach(({amount}) => {
                totalImageAmount += amount
            })
        }

        if (
            frameSize &&
            ('SETS' === selectedShape || 'COLLECTION' === selectedShape) &&
            quantitySet > 0
        ) {
            totalImageAmount = Math.floor(totalImageAmount / quantitySet)
        }

        if(signature) {
            totalPrice+= 10; // PM-441
        }

        totalPrice *= totalImageAmount !== 0 ? totalImageAmount : 1

        setTotalPrice(totalPrice)
    }
}

export default useCalculateTotalPrice
